module.exports = __webpack_public_path__ + "media/Aria_Floodlight_Installation_Steps-7-8.fa3607f0.mp4";